import CompareCommunication from '~/pages/communication/compare/libs/components/CompareCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const CompareCommunicationPage = (props: TPageProps) => (
  <CompareCommunication {...props} />
)

export default CompareCommunicationPage
